module.exports = __webpack_public_path__ + "img/banner.4f7c6446.png";